import React, { useEffect, useState } from "react";
import { getCurrentUser } from "../../auth";
import { getSISSettings } from "../../services/sisAcademicService";

function toEmbedUrl(url) {
  const u = String(url || "").trim();
  if (!u) return "";
  if (u.includes("/pubhtml")) return u;
  if (u.includes("/edit")) return u.replace("/edit", "/preview");
  return u;
}

export default function TeacherCalendar() {
  const user = getCurrentUser();
  const campus = String(user?.campus || "gapan").toLowerCase();
  const [embedUrl, setEmbedUrl] = useState("");
  const [schoolYear, setSchoolYear] = useState("");

  useEffect(() => {
    (async () => {
      const s = await getSISSettings(campus);
      setSchoolYear(String(s?.schoolYear || ""));
      setEmbedUrl(toEmbedUrl(s?.calendarEmbedUrl || ""));
    })();
  }, [campus]);

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h3 className="mb-0">School Calendar</h3>
          <div className="text-muted">{schoolYear ? `School Year: ${schoolYear}` : ""}</div>
        </div>
        {embedUrl && (
          <button className="btn btn-outline-secondary" onClick={() => window.open(embedUrl, "_blank", "noopener,noreferrer")}>
            Open
          </button>
        )}
      </div>

      {!embedUrl ? (
        <div className="card p-3">
          <div className="text-muted">
            No calendar embed URL set yet. Ask admin/registrar to set it in SIS → School Year Manager.
          </div>
        </div>
      ) : (
        <div className="card" style={{ overflow: "hidden" }}>
          <div style={{ padding: 12, borderBottom: "1px solid var(--theme-border)", background: "#fff" }}>
            <div style={{ fontWeight: 800 }}>Calendar</div>
            <div className="text-muted small">Embedded view</div>
          </div>
          <div style={{ width: "100%", height: "78vh", minHeight: 560, background: "#fff" }}>
            <iframe
              title="School Calendar"
              src={embedUrl}
              style={{ width: "100%", height: "100%", border: 0 }}
              allowFullScreen
            />
          </div>
        </div>
      )}
    </div>
  );
}

